import { render, staticRenderFns } from "./alignLeft_off.vue?vue&type=template&id=081d7f4e&"
import script from "./alignLeft_off.vue?vue&type=script&lang=ts&"
export * from "./alignLeft_off.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports